"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.accountDetectionApi = accountDetectionApi;
exports.copyrightInfoApi = copyrightInfoApi;
exports.frontDomainApi = frontDomainApi;
exports.getApplyQryApi = getApplyQryApi;
exports.getMerchantRegUrlApi = getMerchantRegUrlApi;
exports.getSystemColorApi = getSystemColorApi;
exports.sendQueryCodeApi = sendQueryCodeApi;
exports.sendSigningCodeApi = sendSigningCodeApi;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

/**
 * 获取版权信息
 */
function copyrightInfoApi() {
  return (0, _request.default)({
    url: '/admin/merchant/copyright/get/company/info',
    method: 'get'
  });
}

/**
 * @description 账号登录检测
 */
function accountDetectionApi(data) {
  return (0, _request.default)({
    url: '/admin/merchant/login/account/detection',
    method: 'post',
    data: data
  });
}

/**
 * 获取移动端域名
 */
function frontDomainApi() {
  return (0, _request.default)({
    url: '/publicly/config/get/front/domain',
    method: 'get'
  });
}

/**
 * 获取移动端主题色
 */
function getSystemColorApi() {
  return (0, _request.default)({
    url: '/publicly/config/get/change/color',
    method: 'get'
  });
}

/**
 * @description 获取商户签约入驻链接
 * @param {Object} data - { nameOrCompany: string, phone: string, code: string }
 */
function getMerchantRegUrlApi(data) {
  return (0, _request.default)({
    url: '/admin/merchant/signing/getMerchantRegUrl',
    method: 'post',
    data: data
  });
}

/**
 * @description 发送商户入驻验证码
 * @param {Object} params - { phone: string }
 */
function sendSigningCodeApi(params) {
  return (0, _request.default)({
    url: '/admin/merchant/sms/send-signing-code',
    method: 'post',
    params: params
  });
}

/**
 * @description 查询商户入驻申请
 * @param {Object} data - { phone: string, code: string }
 */
function getApplyQryApi(data) {
  return (0, _request.default)({
    url: '/admin/merchant/signing/getApplyQry',
    method: 'post',
    data: data
  });
}

/**
 * @description 发送查询入驻验证码
 * @param {Object} params - { phone: string }
 */
function sendQueryCodeApi(params) {
  return (0, _request.default)({
    url: '/admin/merchant/sms/send-query-code',
    method: 'post',
    params: params
  });
}